export default function mean(data: number[]): number {
  return data.reduce((sum, value) => sum + value, 0) / data.length
}
